import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/company/members/groups')({
  beforeLoad: async () => {
    return redirect({ to: '/company/groups' })
  },
})
